// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1U-3V","unreadBadge":"styles_unreadBadge__3M3m_","modalContent":"styles_modalContent__1ufQi","modal":"styles_modal__19Uwf"};